var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.7683 19.0431C33.7683 27.4516 26.9518 34.2681 18.5433 34.2681C10.1348 34.2681 3.31836 27.4516 3.31836 19.0431C3.31836 10.6346 10.1348 3.81812 18.5433 3.81812C26.9518 3.81812 33.7683 10.6346 33.7683 19.0431Z",
    fill: "url(#paint0_linear_43_651)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8618 29.7176C23.7802 31.1476 21.2594 31.9843 18.5431 31.9843C15.8268 31.9843 13.3061 31.1474 11.2245 29.7175C10.3051 29.086 9.91223 27.883 10.4468 26.9041C11.5549 24.8746 13.8382 23.6106 18.5431 23.6106C23.2481 23.6106 25.5314 24.8747 26.6395 26.9041C27.174 27.883 26.7811 29.0861 25.8618 29.7176Z",
    fill: "url(#paint1_linear_43_651)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5435 19.0432C21.0661 19.0432 23.111 16.9983 23.111 14.4757C23.111 11.9531 21.0661 9.9082 18.5435 9.9082C16.021 9.9082 13.9761 11.9531 13.9761 14.4757C13.9761 16.9983 16.021 19.0432 18.5435 19.0432Z",
    fill: "url(#paint2_linear_43_651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_651",
    x1: 3.31836,
    y1: 3.81812,
    x2: 40.0329,
    y2: 17.7011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158668,
    stopColor: "#F76A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60652,
    stopColor: "#A24AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891362,
    stopColor: "#4859F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43_651",
    x1: 10.2051,
    y1: 23.6106,
    x2: 24.8706,
    y2: 34.6543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158668,
    stopColor: "#F76A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60652,
    stopColor: "#A24AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891362,
    stopColor: "#4859F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_43_651",
    x1: 13.9761,
    y1: 9.9082,
    x2: 24.9904,
    y2: 14.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158668,
    stopColor: "#F76A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60652,
    stopColor: "#A24AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891362,
    stopColor: "#4859F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMes);
export default __webpack_public_path__ + "static/media/userMes.8c97b439b7ebd9597ec9aa3e6e36d88d.svg";
export { ForwardRef as ReactComponent };